import * as React from 'react';
import { FC, useState, useEffect } from 'react';

const formattedTime = (value: number) => (value < 10 ? `0${value}` : value);

const Timer: FC = () => {
  const [time, setTime] = useState(new Date());

  const updateTime = () => {
    setTime(new Date());
  };

  useEffect(() => {
    const i = setInterval(updateTime, 1000);
    return () => clearInterval(i);
  }, []);

  return (
    <div className="timer">
      {formattedTime(time.getHours())}:{formattedTime(time.getMinutes())}
    </div>
  );
};

export default Timer;
